import React, { useEffect } from "react";
import { useTheme } from '@mui/material/styles';
import {
  Grid,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import ToastMessage from "../../../components/layout/ToastMessage";
import { sendVerificationEmail } from "../../../redux/actions/auth";


function VerifyEmailForm() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { email } = state;

  useEffect(() => {
    toast(<ToastMessage title="Verification Email Sent" message="Please check your email to complete the signup." />, {closeButton: false});
  }, []);

  const onSend = async () => {
    const data = { email };
    const res = await dispatch(sendVerificationEmail(data));
    if (res.result) {
      toast(<ToastMessage title="Verification Email Sent" message="Please check your email to complete the signup." />, {closeButton: false});
    }
  }

  return (
    <Grid
      justifyContent='center'
      sx={{
        width: { sm: '550px' },
        minHeight: '300px',
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d',
        borderRadius: '0.625rem',
        padding: { xs: 4, md: '4rem' }
      }}
    >
      <Box
        display='flex'
        flexDirection='column'
        component='form'
        noValidate
        autoComplete='off'
      >
        <Typography sx={{ fontWeight: 600, textAlign: 'center', fontSize: '1.4rem' }}>Please verify your email</Typography>
        <Typography sx={{ mt: 2, fontSize: '14px', textAlign: 'center', color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>
          Almost there! We sent a verification email to
        </Typography>
        <Typography sx={{ fontSize: '14px', textAlign: 'center', textDecoration: 'underline', color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>
          {email}
        </Typography>
        <Typography sx={{ mt: 2, fontSize: '14px', textAlign: 'center', color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>
          Please click on the link in that email to complete your signup. If you don't see it, you may need to check your spam folder.
        </Typography>
        <Typography sx={{ mt: 1, fontSize: '14px', textAlign: 'center', color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>Still can't find the email? No problem.</Typography>
        
        <Button
          onClick={onSend}
          variant="contained"
          color="primary"
          sx={{ mt: 3, color: '#fff', fontWeight: 600, height: '2.5rem', textTransform: 'none' }}
        >
          Resend Verification Email
        </Button>
        <Grid container justifyContent='center'>
          <Typography sx={{ mt: 3, fontSize: '14px', textAlign: 'center' }}><span style={{ color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>Need help?</span> <Link to='mailto:team@clientl.app'>Contact us</Link></Typography>
        </Grid>
      </Box>
    </Grid>
  );
}

export default VerifyEmailForm;
